<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    values: {
      type: Array,
      default: () => [],
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
    exportButtonVisible: {
      type: Boolean,
      default: false,
    },
    internalUser: {
      type: Boolean,
      default: false,
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
    gridFilters: {
      type: Boolean,
      default: true,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
    isGridDataLoaded: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
